module.exports = __webpack_public_path__ + "static/media/e-coop_logo-01.3c9f4ea4.svg";